/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */

/**
 * Type guard for JustifyContent
 * @param justifyContent - the element to guard the type for
 */
export function isJustifyContent(justifyContent) {
  switch (justifyContent) {
    case 'SpaceGreedily':
    case 'SpaceEvenly':
    case 'SpaceGreedilyPreferRoundIndices':
      return true;

    default:
      return false;
  }
}
/**
 * Returns the given value if its type is valid or the fallback-parameter.
 * @param justifyContent - the value value to be sanitized
 * @param fallback - the value to be used as fallback if the type is invalid
 * @returns the sanitized value
 */

export function sanitizeJustifyContent(justifyContent, fallback = 'SpaceGreedily') {
  if (isJustifyContent(justifyContent)) {
    return justifyContent;
  }

  if (!isJustifyContent(fallback)) {
    throw new Error(`The provided fallback "${fallback}" is not of the correct type`);
  } // eslint-disable-next-line


  console.warn(`"${justifyContent}" is not a valid value; "${fallback}" will be used instead`);
  return fallback;
}
